/**
 * "yyyy-MM-dd" yoki ISO sana stringini o'zbek tilidagi qisqa formatga o'tkazadi.
 * Misol: "2026-04-16" → "16 apr, chorshanba"
 */
export function formatDate(dateStr: string): string {
  const date = new Date(dateStr.length === 10 ? dateStr + 'T00:00:00' : dateStr);
  return date.toLocaleDateString('uz-UZ', {
    day: 'numeric',
    month: 'short',
    weekday: 'long',
  });
}

/**
 * "yyyy-MM-dd" yoki ISO sana stringini qisqa format (kun, oy).
 * Misol: "2026-04-16" → "16 apr"
 */
export function formatDateShort(dateStr: string): string {
  const date = new Date(dateStr.length === 10 ? dateStr + 'T00:00:00' : dateStr);
  return date.toLocaleDateString('uz-UZ', {
    day: 'numeric',
    month: 'short',
  });
}
